import styled from '@emotion/styled'
import Evaluation from 'components/feature/NavigatorPanes/editors/base/Evaluation'
import { Label } from 'components/chec'

export const StyledImg = styled.span`
  line-height: 16px;
  svg {
    height: 16px;
  }
`

export const StyledInputLabel = styled(Label)`
  display: block;
  margin-bottom: 5px;
`

export const StyledEvaluation = styled(Evaluation)`
  margin-top: 15px;
`

export const ReadOnlyContainer = styled('div')`
  & .output-container {
    margin-top: 4px;
  }
`;
